<mic-table [config]="tableConfig" [dataSource]="dataSource">
  <ng-container *micCellTemplate="let script; name: 'Run'">
    <mat-icon class="run-icon" (click)="onRunScript(script)"> description</mat-icon>
  </ng-container>
  <ng-container *micRowDetail="let item">
    <div>
      @if (scriptStatus !== undefined) {
      <div class="toto">
        <div class="historique">
          <div class="historique-body">
            <span matTooltip="userName" [matTooltipPosition]="'above'" class="material-icons"> person </span>
            <p>{{ scriptStatus.username }}</p>
          </div>
          <div class="historique-body">
            <span matTooltip="StartDate" [matTooltipPosition]="'above'" class="material-icons"> hourglass_top </span>
            <p>{{ utilService.methodTest(scriptStatus.startDate) }}</p>
          </div>
          <div class="historique-body">
            <span matTooltip="EndDate" [matTooltipPosition]="'above'" class="material-icons"> hourglass_bottom </span>
            <p>{{ scriptStatus.updateDate !== null ? utilService.methodTest(scriptStatus.updateDate) : 'Not Yet' }}</p>
          </div>
          <div class="historique-body">
            <mic-icon icon="monitoring"></mic-icon>
            @if (scriptStatus.status === 'OK') {
            <mat-icon [class]="scriptStatus.status">{{ utilService.getTableRowStatusIcon(scriptStatus.status) }}</mat-icon>
            } @else {
            <mic-spinner class="test" color="primary" [strokeWidth]="5"></mic-spinner>
            }
          </div>
          <div class="historique-body">
            <mic-icon style="cursor: pointer" (click)="onHistoric()" icon="history"></mic-icon>
          </div>
        </div>
      </div>
      }
    </div>
  </ng-container>
</mic-table>
